var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileImage = function SvgIconFileImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2A1.75 1.75 0 0 0 3.5 3.75V12a1 1 0 1 0 2 0V4h7.375v4.625a1 1 0 0 0 1 1H18.5V20h-.125a1 1 0 1 0 0 2h.375a1.75 1.75 0 0 0 1.75-1.75v-12a1 1 0 0 0-.293-.707l-5.25-5.25A1 1 0 0 0 14.25 2zm12.21 5.625-2.585-2.586v2.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09 13.718a1.366 1.366 0 0 1 1.806.453l4.186 6.274A1 1 0 0 1 14.25 22h-12a1 1 0 0 1-.842-1.54l3.057-4.763.012-.018a1.385 1.385 0 0 1 2.296 0l.012.018.395.614 1.423-2.14c.123-.188.29-.344.487-.453m.66 2.34L8.31 18.22a1.375 1.375 0 0 1-2.3-.03l-.385-.6L4.08 20h8.3z"
  }))));
};
export default SvgIconFileImage;